import { Button, Form, Input, message, Modal, Select } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import gql from 'graphql-tag';
import React, { Component } from 'react';
import { Mutation } from 'react-apollo';

import { PERMISSION_ACTIONS, PERMISSION_POSSESSIONS, USER_ROLE_PERMISSIONS_QUERY } from './constant';

interface State {
  isShowModal: boolean;
  description: string;
  action: string;
  resource: string;
  possession: string;
  attributes: string[];
}

interface Props {
  form: WrappedFormUtils;
}

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

const createUserRolePermissionMutation = gql`
  mutation createUserRolePermission(
    $action: String!
    $resource: String!
    $description: String!
    $possession: String!
    $attributes: [String]!
  ) {
    createUserRolePermission(
      action: $action
      resource: $resource
      description: $description
      possession: $possession
      attributes: $attributes
    ) {
      id
      action
      resource
      description
    }
  }
`;

export class AddPermission extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isShowModal: false,
      description: '',
      action: '',
      resource: '',
      possession: '',
      attributes: [],
    };
  }

  hideModal = () => {
    this.setState({ isShowModal: false });
  };

  showModal = () => {
    this.setState({ isShowModal: true });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { description, action, resource, possession, attributes, isShowModal } = this.state;
    return (
      <div>
        <Button icon="plus" onClick={this.showModal}>
          新增
        </Button>
        <Mutation
          mutation={createUserRolePermissionMutation}
          variables={{ description, action, resource, possession, attributes }}
          refetchQueries={[{ query: USER_ROLE_PERMISSIONS_QUERY }]}
        >
          {createUserRolePermission => {
            return (
              <Modal
                title="添加用户权限"
                visible={isShowModal}
                onOk={() => {
                  this.props.form.validateFields(async (err, values) => {
                    if (err) {
                      message.error(err);
                      return;
                    }
                    try {
                      if (
                        values.action &&
                        values.description &&
                        values.resource &&
                        values.possession &&
                        values.attributes &&
                        values.attributes.length
                      ) {
                        this.setState(
                          {
                            attributes: [values.attributes],
                            description: values.description,
                            action: values.action,
                            possession: values.possession,
                            resource: values.resource,
                            isShowModal: false,
                          },
                          async () => {
                            await createUserRolePermission();
                            this.setState({ isShowModal: false });
                            message.success('添加成功！');
                            return;
                          },
                        );
                      } else {
                        message.error('请将信息填写完整！');
                      }
                    } catch {
                      message.error('添加失败！');
                    }
                  });
                }}
                onCancel={this.hideModal}
              >
                <Form>
                  <Form.Item label="权限描述" {...formItemLayout}>
                    {getFieldDecorator('description', {
                      rules: [
                        {
                          required: true,
                          message: '请填写权限描述',
                        },
                      ],
                    })(<Input placeholder="权限描述" />)}
                  </Form.Item>
                  <Form.Item {...formItemLayout} label="权限行为">
                    {getFieldDecorator('action', {
                      rules: [
                        {
                          required: true,
                          message: '权限行为',
                        },
                      ],
                    })(
                      <Select style={{ width: '100%' }} placeholder="请选择">
                        {PERMISSION_ACTIONS.map(value => {
                          return <Select.Option key={value}>{value}</Select.Option>;
                        })}
                      </Select>,
                    )}
                  </Form.Item>
                  <Form.Item {...formItemLayout} label="权限来源组件">
                    {getFieldDecorator('resource', {
                      rules: [
                        {
                          required: true,
                          message: '权限来源组件',
                        },
                      ],
                    })(<Input placeholder="权限来源组件" />)}
                  </Form.Item>
                  <Form.Item {...formItemLayout} label="权限拥有者">
                    {getFieldDecorator('possession', {
                      rules: [
                        {
                          required: true,
                          message: '权限拥有者',
                        },
                      ],
                    })(
                      <Select style={{ width: '100%' }} placeholder="请选择">
                        {PERMISSION_POSSESSIONS.map(value => {
                          return <Select.Option key={value}>{value}</Select.Option>;
                        })}
                      </Select>,
                    )}
                  </Form.Item>
                  <Form.Item {...formItemLayout} label="权限属性">
                    {getFieldDecorator('attributes', {
                      rules: [
                        {
                          required: true,
                          message: '权限属性',
                        },
                      ],
                    })(<Input placeholder="权限属性" />)}
                  </Form.Item>
                </Form>
              </Modal>
            );
          }}
        </Mutation>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/rolePermission/AddPermission.tsx